/**
 * 运营 - 其他途径批次（REQ-005 F010 前端，T-020；REQ-008 F005/F006 弹窗化改造，T-029）
 *
 * 页面结构（契约 API-014 v1.2.0，T-030 后端已实现）：
 * 1. 批次列表卡片：搜索表单置顶（商户/服务商/结算月份）+ 全字段分页表格
 *    （17 列；服务商标签与列头文案同步(AC-004-03)，增值税列头改为"增值税"，绑定字段 vatRate（T-028 契约 v1.1.0）；
 *    代理商单列已删除，改一级/二级/三级代理三列并排（T-031，REQ-009 F003 契约 v1.2.0：
 *    firstAgentName/secondAgentName/thirdAgentName，未配置显示"-"，列序在服务商之后，与商户档案列表口径一致）；
 *    底价列追加在管理费率列之后（T-037，REQ-012 F004 契约 v1.4.0：绑定 bottomRate，
 *    复用 fmt4 展示——空值"-"，0 正常显示 0.0000（存量 0 不做"-"处理），既有列全部保留））
 *    按钮区（REQ-010 F001，T-032）：搜索表单下方、表格上方左对齐——模板下载（沿用 downloadTemplate）
 *    + 导入批次（打开导入弹窗，AC-005-03；原「选择文件」改名，卡片 header 仅保留「批次列表」标题）
 * 2. 导入弹窗（el-dialog，REQ-008 F005 弹窗化 + REQ-010 F002 纵向单列重排，T-032）：
 *    内嵌 el-upload（accept=.xlsx, auto-upload=false, limit=1）→ 选中后弹窗内回显文件名（AC-005-04，独立成行）
 *    → "导入"按钮独占一行（未选文件提示"请先选择 .xlsx 文件"不发请求 AC-005-05；导入中 loading 防重复）
 *    → 导入结果在弹窗内展示（成功 N 行/失败 M 行 + 失败明细表 行号+原因，AC-005-06）
 *    → 弹窗最底部一行灰色小字精简注释（REQ-010 AC-002-02）
 *    导入成功后列表自动刷新并重置第一页（FX-T020-01，AC-005-07），弹窗保持打开由用户手动关闭（REQ-008 §9 #5）
 * 3. 列尾固定操作列：表格最右 fixed="right"，"修改/删除"描边按钮 nowrap 强制一行（横向滚动永远可见，既有 17 列列序不变）
 * 4. 修改弹窗（el-dialog）：行数据直接回填 17 项业务字段（列表 VO 已含 id 与关联 id/名称，零额外请求）；
 *    商户/服务商/电销/面销/一二级三级代理均为可搜索下拉、存 id（数据源：company type=1/2、salespersons 在职、agent 列表）；
 *    代理商可清空=未配置；NOT NULL 列空值前端拦截提示不发请求（转交标志/结算时间/13 项数值与关联字段必填）；
 *    保存调单条修改接口全字段覆盖回写，成功刷新当前页（不重置页码），失败透出后端 msg
 * 5. 删除：行内"删除"→ 确认框 → 物理删除单条 → 成功刷新列表（当前页删空自动回退上一页），取消不发请求
 *
 * 边界（任务描述 + REQ-005 §9 #13）：
 * - 仅支持 .xlsx（前端先校验扩展名拦截 AC-005-08，后端 702 兜底）；单文件 ≤1000 行提示文案随迁弹窗
 * - 大文件（>1000 行）→ 弹窗内说明文字提示，后端解析超限返回 702 时展示后端 msg
 * - 覆盖导入成功后列表自动刷新展示新值
 * - 电销/面销/是否转交标志由后端按 customer_sales_relation 自动带出，运营无需关心来源（REQ-005 §9 #5）
 */
<template>
  <div class="other-channel-batch-page">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/oms/customerSignOrder' }">运营</el-breadcrumb-item>
      <el-breadcrumb-item>其他途径批次</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- ==================== 批次列表卡片（搜索置顶 + 按钮区在表格上方，REQ-010 F001/T-032） ==================== -->
    <el-card class="list-card" shadow="never">
      <div slot="header" class="card-header">
        <span>批次列表</span>
      </div>

      <el-form :inline="true" :model="queryForm" size="small" class="filter-form">
        <el-form-item label="商户">
          <el-input
            v-model="queryForm.merchantName"
            placeholder="商户名称，模糊匹配"
            clearable
            style="width: 200px"
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务商">
          <el-input
            v-model="queryForm.disCompanyName"
            placeholder="服务商名称，模糊匹配"
            clearable
            style="width: 200px"
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="结算月份">
          <el-date-picker
            v-model="queryForm.settlementMonth"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份"
            style="width: 140px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 按钮区（REQ-010 F001/T-032：搜索表单下方、表格上方，左对齐；点击行为零变化 AC-001-03） -->
      <div class="list-actions">
        <el-button size="small" :loading="templateLoading" @click="downloadTemplate">模板下载</el-button>
        <el-button size="small" type="primary" @click="openImportDialog">导入批次</el-button>
      </div>

      <el-table :data="list" border size="small" v-loading="listLoading" empty-text="暂无批次数据">
        <el-table-column label="商户" prop="merchantName" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column label="服务商" prop="disCompanyName" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column label="一级代理" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.firstAgentName || "-" }}</template>
        </el-table-column>
        <el-table-column label="二级代理" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.secondAgentName || "-" }}</template>
        </el-table-column>
        <el-table-column label="三级代理" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.thirdAgentName || "-" }}</template>
        </el-table-column>
        <el-table-column label="管理费率" width="110" align="right">
          <template slot-scope="{ row }">{{ fmt4(row.managementFeeRate) }}</template>
        </el-table-column>
        <!-- 底价列（T-037，REQ-012 F004 契约 v1.4.0）：紧邻管理费率列，fmt4 空值"-"、0 正常显示 -->
        <el-table-column label="底价" width="110" align="right">
          <template slot-scope="{ row }">{{ fmt4(row.bottomRate) }}</template>
        </el-table-column>
        <el-table-column label="个税税率" width="110" align="right">
          <template slot-scope="{ row }">{{ fmt4(row.individualIncomeTaxRate) }}</template>
        </el-table-column>
        <el-table-column label="增值税" width="110" align="right">
          <template slot-scope="{ row }">{{ fmt4(row.vatRate) }}</template>
        </el-table-column>
        <el-table-column label="附加税率" width="110" align="right">
          <template slot-scope="{ row }">{{ fmt4(row.additionalTaxRate) }}</template>
        </el-table-column>
        <el-table-column label="电销" min-width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.phoneSalesName || "-" }}</template>
        </el-table-column>
        <el-table-column label="面销" min-width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.faceSalesName || "-" }}</template>
        </el-table-column>
        <el-table-column label="是否转交电销" width="110" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.transferPhoneFlag === 1 ? 'warning' : 'info'" size="mini">{{ row.transferPhoneFlag === 1 ? "已转交" : "未转交" }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否转交面销" width="110" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.transferFaceFlag === 1 ? 'warning' : 'info'" size="mini">{{ row.transferFaceFlag === 1 ? "已转交" : "未转交" }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="结算时间" prop="settlementDate" width="110" align="center"></el-table-column>
        <el-table-column label="服务费" width="120" align="right">
          <template slot-scope="{ row }">{{ fmt4(row.serviceFee) }}</template>
        </el-table-column>
        <el-table-column label="管理费" width="120" align="right">
          <template slot-scope="{ row }">{{ fmt4(row.managementFee) }}</template>
        </el-table-column>
        <!-- 列尾固定操作列：横向滚动钉在右侧，修改/删除描边按钮，nowrap 强制一行 -->
        <el-table-column label="操作" fixed="right" align="center" width="150" class-name="op-col-buttons">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" plain @click="openEditDialog(row)">修改</el-button>
            <el-button type="danger" size="mini" plain @click="handleDeleteBatch(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="page-pagination"
        background
        layout="total, sizes, prev, pager, next"
        :total="totalCount"
        :current-page.sync="queryForm.page"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        @current-change="loadList"
        @size-change="handleSizeChange"
      ></el-pagination>
    </el-card>

    <!-- ==================== 导入弹窗（REQ-008 F005：原"批次导入"卡片整体迁入弹窗） ==================== -->
    <el-dialog
      title="批次导入"
      :visible.sync="importDialogVisible"
      width="640px"
      :close-on-click-modal="false"
      @closed="handleImportDialogClosed"
    >
      <!-- 弹窗内容纵向单列（REQ-010 F002/T-032，AC-002-01：统一左内边距约 24px，整体左对齐） -->
      <div class="import-dialog-content">
        <el-upload
          ref="upload"
          class="upload-demo"
          action=""
          accept=".xlsx"
          :auto-upload="false"
          :limit="1"
          :file-list="fileList"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
          :on-exceed="handleFileExceed"
        >
          <el-button size="small" type="primary" slot="trigger">选取文件</el-button>
        </el-upload>
        <el-button
          size="small"
          type="success"
          class="import-submit-btn"
          :loading="importing"
          @click="importFile"
        >导入</el-button>

        <!-- 导入结果反馈（AC-005-06：成功 N 行 / 失败 M 行 + 失败明细；位置=导入按钮下方、底部注释之上，AC-002-04） -->
        <div v-if="importResult" class="import-result">
          <el-alert
            :type="importResult.failCount > 0 ? 'warning' : 'success'"
            :closable="false"
            show-icon
            :title="importResult.failCount > 0
              ? `导入完成：成功 ${importResult.successCount} 行，失败 ${importResult.failCount} 行`
              : `导入成功：共 ${importResult.successCount} 行`"
          ></el-alert>
          <el-table
            v-if="importResult.errors && importResult.errors.length"
            :data="importResult.errors"
            border
            size="mini"
            class="import-error-table"
          >
            <el-table-column label="Excel 行号" prop="row" width="120"></el-table-column>
            <el-table-column label="失败原因" prop="reason"></el-table-column>
          </el-table>
        </div>

        <!-- 精简注释置底（REQ-010 F002 AC-002-02，方案 2 用户 2026-09-03 拍板） -->
        <div class="import-dialog-tip">仅支持导入 .xlsx 文件，单文件 ≤1000 行；重复导入为覆盖式，服务费/管理费自动求和覆盖；底价由系统按服务商档案自动带出，模板中无需填写</div>
      </div>
    </el-dialog>

    <!-- ==================== 修改弹窗：行数据回填 17 项，NOT NULL 项前端拦截，保存全字段覆盖提交 ==================== -->
    <el-dialog
      title="修改批次"
      :visible.sync="editDialogVisible"
      width="760px"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" size="small" label-width="110px" class="edit-form">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="商户">
              <el-select v-model="editForm.merchant" filterable placeholder="请选择商户" style="width: 100%">
                <el-option v-for="item in merchantOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务商">
              <el-select v-model="editForm.disCompany" filterable placeholder="请选择服务商" style="width: 100%">
                <el-option v-for="item in disCompanyOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="一级代理">
              <el-select v-model="editForm.firstAgent" filterable clearable placeholder="未配置可留空" style="width: 100%">
                <el-option v-for="item in agentOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="二级代理">
              <el-select v-model="editForm.secondAgent" filterable clearable placeholder="未配置可留空" style="width: 100%">
                <el-option v-for="item in agentOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="三级代理">
              <el-select v-model="editForm.thirdAgent" filterable clearable placeholder="未配置可留空" style="width: 100%">
                <el-option v-for="item in agentOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电销">
              <el-select v-model="editForm.phoneSales" filterable placeholder="请选择电销" style="width: 100%">
                <el-option v-for="item in salesOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="面销">
              <el-select v-model="editForm.faceSales" filterable placeholder="请选择面销" style="width: 100%">
                <el-option v-for="item in salesOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否转交电销">
              <el-select v-model="editForm.transferPhoneFlag" style="width: 100%">
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="是否转交面销">
              <el-select v-model="editForm.transferFaceFlag" style="width: 100%">
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结算时间">
              <el-date-picker
                v-model="editForm.settlementDate"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择月份"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="管理费率">
              <el-input v-model="editForm.managementFeeRate" placeholder="如 0.0800 表示 8%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="底价">
              <el-input v-model="editForm.bottomRate" placeholder="如 0.0600 表示 6%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="个税税率">
              <el-input v-model="editForm.individualIncomeTaxRate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="增值税">
              <el-input v-model="editForm.vatRate"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="附加税率">
              <el-input v-model="editForm.additionalTaxRate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务费">
              <el-input v-model="editForm.serviceFee"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="管理费">
              <el-input v-model="editForm.managementFee"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="editSaving" @click="saveEdit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  downloadOtherChannelTemplate,
  importOtherChannelBatch,
  getOtherChannelBatchList,
  updateOtherChannelBatch,
  deleteOtherChannelBatch,
  getAgentPageList,
  getCompanyNameList,
  getSalesList
} from "../../api/userMG";

export default {
  name: "otherChannelBatch",
  data() {
    return {
      // ===== 列表区 =====
      queryForm: {
        merchantName: "",
        disCompanyName: "",
        settlementMonth: "",
        page: 1,
        pageSize: 20
      },
      list: [],
      totalCount: 0,
      listLoading: false,
      // ===== 导入弹窗（REQ-008 F005） =====
      importDialogVisible: false,
      templateLoading: false,
      importing: false,
      fileList: [],
      importResult: null,
      // ===== 修改弹窗 =====
      editDialogVisible: false,
      editSaving: false,
      editForm: {
        id: null,
        merchant: null,
        disCompany: null,
        firstAgent: null,
        secondAgent: null,
        thirdAgent: null,
        phoneSales: null,
        faceSales: null,
        transferPhoneFlag: null,
        transferFaceFlag: null,
        settlementDate: "",
        managementFeeRate: "",
        individualIncomeTaxRate: "",
        vatRate: "",
        additionalTaxRate: "",
        bottomRate: "",
        serviceFee: "",
        managementFee: ""
      },
      merchantOptions: [],
      disCompanyOptions: [],
      agentOptions: [],
      salesOptions: [],
      editOptionsLoaded: false,
      editOptionsLoading: false
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    // ==================== 导入弹窗 ====================
    // 打开弹窗：重置上次导入残留（文件/结果），保证每次打开为干净状态
    openImportDialog() {
      this.fileList = [];
      this.importResult = null;
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
      this.importDialogVisible = true;
    },
    // 弹窗关闭后清理（导入成功后弹窗保持打开由用户手动关闭，REQ-008 §9 #5）
    handleImportDialogClosed() {
      this.fileList = [];
      this.importResult = null;
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    // 模板下载：blob 响应，创建 <a> 触发下载
    async downloadTemplate() {
      this.templateLoading = true;
      try {
        const blob = await downloadOtherChannelTemplate();
        // 响应拦截器已处理错误（403/401 等走 error 分支提示），此处 blob 为文件流
        if (!blob || !(blob instanceof Blob)) {
          this.$message.error("模板下载失败");
          return;
        }
        const href = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = href;
        a.download = "其他途径批次导入模板.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(href);
      } catch (e) {
        this.$message.error("模板下载失败，请重试");
      } finally {
        this.templateLoading = false;
      }
    },
    handleFileChange(file) {
      // el-upload on-change：选中文件（limit=1，取最新）；非 .xlsx 前端拦截（AC-005-08，后端 702 兜底）
      const fileName = (file && file.name) || "";
      if (fileName && !fileName.toLowerCase().endsWith(".xlsx")) {
        this.$message.warning("仅支持 .xlsx 格式文件");
        this.fileList = [];
        if (this.$refs.upload) {
          this.$refs.upload.clearFiles();
        }
        return;
      }
      this.fileList = file && file.raw ? [{ name: file.name, raw: file.raw }] : [];
      this.importResult = null;
    },
    handleFileRemove() {
      this.fileList = [];
      this.importResult = null;
    },
    handleFileExceed() {
      this.$message.warning("只能选择一个文件，请先移除已选文件");
    },
    // 导入（AC-005-05/06/07：未选文件不发请求 + 结果弹窗内展示 + 成功后列表自动刷新重置第一页）
    async importFile() {
      if (!this.fileList.length) {
        this.$message.warning("请先选择 .xlsx 文件");
        return;
      }
      const raw = this.fileList[0].raw;
      const fileName = (raw && raw.name) || "";
      if (!fileName.toLowerCase().endsWith(".xlsx")) {
        this.$message.warning("仅支持 .xlsx 格式文件");
        return;
      }
      this.importing = true;
      try {
        const formData = new FormData();
        formData.append("file", raw);
        const res = await importOtherChannelBatch(formData);
        if (res && res.code === 0) {
          const d = res.data || {};
          this.importResult = d;
          if (d.failCount > 0) {
            this.$message.warning(`导入完成：成功 ${d.successCount} 行，失败 ${d.failCount} 行`);
          } else {
            this.$message.success(`导入成功 ${d.successCount} 行`);
          }
          // 清空已选文件 + 列表自动刷新展示新值（覆盖导入，FX-T020-01 重置第一页）
          // 弹窗保持打开展示结果，由用户手动关闭（REQ-008 §9 #5）
          this.fileList = [];
          if (this.$refs.upload) {
            this.$refs.upload.clearFiles();
          }
          this.queryForm.page = 1;
          this.loadList();
        } else {
          // 702（空文件/非 xlsx/解析失败/无有效数据/超行数上限/重复上传）→ 展示后端 msg
          this.$message.error((res && res.msg) || "导入失败");
        }
      } catch (e) {
        this.$message.error("导入失败，请重试");
      } finally {
        this.importing = false;
      }
    },

    // ==================== 列表区 ====================
    async loadList() {
      this.listLoading = true;
      try {
        const params = {
          page: this.queryForm.page,
          pageSize: this.queryForm.pageSize
        };
        if (this.queryForm.merchantName) {
          params.merchantName = this.queryForm.merchantName.trim();
        }
        if (this.queryForm.disCompanyName) {
          params.disCompanyName = this.queryForm.disCompanyName.trim();
        }
        if (this.queryForm.settlementMonth) {
          params.settlementMonth = this.queryForm.settlementMonth;
        }
        const res = await getOtherChannelBatchList(params);
        if (res && res.code === 0) {
          const d = res.data || {};
          this.list = d.items || [];
          this.totalCount = d.totalCount || 0;
        } else {
          this.$message.error((res && res.msg) || "列表加载失败");
        }
      } catch (e) {
        this.$message.error("列表加载失败");
      } finally {
        this.listLoading = false;
      }
    },
    handleSearch() {
      this.queryForm.page = 1;
      this.loadList();
    },
    handleReset() {
      this.queryForm = {
        merchantName: "",
        disCompanyName: "",
        settlementMonth: "",
        page: 1,
        pageSize: 20
      };
      this.loadList();
    },
    handleSizeChange() {
      this.queryForm.page = 1;
      this.loadList();
    },

    // ==================== 修改弹窗 ====================
    // 打开弹窗：行数据直接回填（列表 VO 已含 id 与关联 id/名称，无需额外请求），再异步补下拉数据源
    async openEditDialog(row) {
      this.editForm = {
        id: row.id,
        merchant: row.merchant,
        disCompany: row.disCompany,
        firstAgent: row.firstAgent,
        secondAgent: row.secondAgent,
        thirdAgent: row.thirdAgent,
        phoneSales: row.phoneSales,
        faceSales: row.faceSales,
        transferPhoneFlag: row.transferPhoneFlag,
        transferFaceFlag: row.transferFaceFlag,
        settlementDate: row.settlementDate || "",
        managementFeeRate: this.toInputValue(row.managementFeeRate),
        individualIncomeTaxRate: this.toInputValue(row.individualIncomeTaxRate),
        vatRate: this.toInputValue(row.vatRate),
        additionalTaxRate: this.toInputValue(row.additionalTaxRate),
        bottomRate: this.toInputValue(row.bottomRate),
        serviceFee: this.toInputValue(row.serviceFee),
        managementFee: this.toInputValue(row.managementFee)
      };
      this.editDialogVisible = true;
      if (!this.editOptionsLoaded && !this.editOptionsLoading) {
        await this.loadEditOptions();
      }
      this.mergeRowAgentOptions(row);
      this.mergeRowSalesOptions(row);
    },
    // 拉取弹窗下拉数据源（只拉一次缓存复用）：商户/服务商=company type，代理商=agent 列表，电销/面销=在职销售
    async loadEditOptions() {
      this.editOptionsLoading = true;
      try {
        const [merchantRes, disCompanyRes, agentRes, salesRes] = await Promise.all([
          getCompanyNameList({ page: 1, pageSize: 9999, type: 1 }),
          getCompanyNameList({ page: 1, pageSize: 9999, type: 2 }),
          getAgentPageList({ page: 1, pageSize: 9999 }),
          getSalesList({ page: 1, pageSize: 9999, status: 1 })
        ]);
        this.merchantOptions = this.pickList(merchantRes, (d) =>
          (Array.isArray(d) ? d : []).map((it) => ({ label: it.label, value: it.value }))
        );
        this.disCompanyOptions = this.pickList(disCompanyRes, (d) =>
          (Array.isArray(d) ? d : []).map((it) => ({ label: it.label, value: it.value }))
        );
        this.agentOptions = this.pickList(agentRes, (d) =>
          ((d && d.records) || []).map((it) => ({ label: it.agentName || it.nickname, value: it.agentId }))
        );
        this.salesOptions = this.pickList(salesRes, (d) =>
          ((d && d.items) || []).map((it) => ({ label: it.name, value: it.id }))
        );
        this.editOptionsLoaded = true;
      } catch (e) {
        this.$message.warning("下拉选项加载失败，请重新打开弹窗");
      } finally {
        this.editOptionsLoading = false;
      }
    },
    // 统一取响应数据（code=0 视为成功，与页面既有判断口径一致）
    pickList(res, extractor) {
      if (res && res.code === 0) {
        return extractor(res.data) || [];
      }
      return [];
    },
    // 代理商兜底：无账号代理商不在 agent 列表接口返回中，用行内名称补选项，保证回显不破
    mergeRowAgentOptions(row) {
      const pairs = [
        [row.firstAgent, row.firstAgentName],
        [row.secondAgent, row.secondAgentName],
        [row.thirdAgent, row.thirdAgentName]
      ];
      pairs.forEach(([id, name]) => {
        if (id !== null && id !== undefined && name && !this.agentOptions.some((it) => it.value === id)) {
          this.agentOptions.push({ label: name, value: id });
        }
      });
    },
    // 电销/面销兜底：在职销售列表接口不含无系统账号的销售，用行内名称补选项，保证回显不破
    mergeRowSalesOptions(row) {
      const pairs = [
        [row.phoneSales, row.phoneSalesName],
        [row.faceSales, row.faceSalesName]
      ];
      pairs.forEach(([id, name]) => {
        if (id !== null && id !== undefined && name && !this.salesOptions.some((it) => it.value === id)) {
          this.salesOptions.push({ label: name, value: id });
        }
      });
    },
    // 数值转输入框字符串：空值显示空白，其余原样
    toInputValue(val) {
      return val === null || val === undefined ? "" : String(val);
    },
    // 保存：NOT NULL 列空值前端拦截（不发请求）；代理商可空=未配置；全 17 字段提交由后端全量覆盖回写
    async saveEdit() {
      const relationChecks = [
        ["merchant", "商户"],
        ["disCompany", "服务商"],
        ["phoneSales", "电销"],
        ["faceSales", "面销"],
        ["transferPhoneFlag", "是否转交电销"],
        ["transferFaceFlag", "是否转交面销"]
      ];
      for (const [key, label] of relationChecks) {
        if (this.editForm[key] === null || this.editForm[key] === undefined || this.editForm[key] === "") {
          this.$message.warning(label + "不能为空");
          return;
        }
      }
      if (!this.editForm.settlementDate) {
        this.$message.warning("结算时间不能为空");
        return;
      }
      const numberFields = [
        ["managementFeeRate", "管理费率"],
        ["bottomRate", "底价"],
        ["individualIncomeTaxRate", "个税税率"],
        ["vatRate", "增值税"],
        ["additionalTaxRate", "附加税率"],
        ["serviceFee", "服务费"],
        ["managementFee", "管理费"]
      ];
      const data = {
        merchant: this.editForm.merchant,
        disCompany: this.editForm.disCompany,
        firstAgent: this.editForm.firstAgent,
        secondAgent: this.editForm.secondAgent,
        thirdAgent: this.editForm.thirdAgent,
        phoneSales: this.editForm.phoneSales,
        faceSales: this.editForm.faceSales,
        transferPhoneFlag: this.editForm.transferPhoneFlag,
        transferFaceFlag: this.editForm.transferFaceFlag,
        settlementDate: this.editForm.settlementDate
      };
      for (const [key, label] of numberFields) {
        const raw = String(this.editForm[key] === null || this.editForm[key] === undefined ? "" : this.editForm[key]).trim();
        if (raw === "") {
          this.$message.warning(label + "不能为空");
          return;
        }
        const n = Number(raw);
        if (isNaN(n)) {
          this.$message.warning(label + "必须为数字");
          return;
        }
        data[key] = n;
      }
      this.editSaving = true;
      try {
        const res = await updateOtherChannelBatch(this.editForm.id, data);
        if (res && res.code === 0) {
          this.$message.success("保存成功");
          this.editDialogVisible = false;
          // 刷新当前页（不重置页码）
          this.loadList();
        } else {
          this.$message.error((res && res.msg) || "保存失败");
        }
      } catch (e) {
        // HTTP 400/500 由响应拦截器统一弹出后端 msg（含唯一键冲突文案），此处仅兜底
      } finally {
        this.editSaving = false;
      }
    },

    // ==================== 删除 ====================
    // 删除确认：确认后物理删除单条并刷新列表（当前页删空自动回退上一页），取消不发请求
    handleDeleteBatch(row) {
      this.$confirm("删除后不可恢复，确定删除该批次吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            const res = await deleteOtherChannelBatch(row.id);
            if (res && res.code === 0) {
              this.$message.success("删除成功");
              if (this.list.length === 1 && this.queryForm.page > 1) {
                this.queryForm.page -= 1;
              }
              this.loadList();
            } else {
              this.$message.error((res && res.msg) || "删除失败");
            }
          } catch (e) {
            // HTTP 400/500 由响应拦截器统一弹出后端 msg，此处仅兜底
          }
        })
        .catch(() => {});
    },

    // ==================== 展示工具 ====================
    // 金额/比例按 4 位小数展示（AC-010-02/AC-006-01；BigDecimal 原样返回，toFixed(4) 展示，空值"-"）
    fmt4(val) {
      if (val === null || val === undefined || val === "") {
        return "-";
      }
      const n = Number(val);
      return isNaN(n) ? "-" : n.toFixed(4);
    }
  }
};
</script>

<style scoped>
.other-channel-batch-page {
  padding: 10px;
}
.page-breadcrumb {
  margin-bottom: 14px;
}
.list-card {
  margin-bottom: 14px;
}
.card-header {
  display: flex;
  align-items: center;
}
/* 按钮区（REQ-010 F001）：搜索表单下方、表格上方，左对齐 */
.list-actions {
  margin: 8px 0 12px;
}
/* 弹窗内容纵向单列（REQ-010 F002）：统一左内边距约 24px */
.import-dialog-content {
  padding-left: 24px;
}
.import-dialog-tip {
  margin-top: 12px;
  color: #909399;
  font-size: 12px;
  line-height: 1.6;
}
.upload-demo {
  display: block;
}
.import-submit-btn {
  margin-top: 12px;
}
.import-result {
  margin-top: 12px;
}
.import-error-table {
  margin-top: 8px;
}
.filter-form {
  margin-bottom: 4px;
}
/* 操作列：单元格自带左右 10px 内边距会挤到换行，nowrap 强制任何分辨率/缩放下按钮都一行 */
.op-col-buttons .cell {
  white-space: nowrap;
}
/* 修改弹窗表单：压缩行距，双列布局更紧凑 */
.edit-form .el-form-item {
  margin-bottom: 14px;
}
.page-pagination {
  margin-top: 12px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/oms/otherChannelBatch.vue